<template>
  <b-row>
    <b-col sm="12">
      <b-card header="Listado de flota">
        <div class="table-responsive">
          <div class="form-group form-inline pull-left">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a
                  class="nav-link"
                  v-bind:class="serviceSelected === 'INL' ? 'active':''"
                  @click="trucksByService(1)"
                >Inland</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  v-bind:class="serviceSelected === 'PORT' ? 'active':''"
                  @click="trucksByService(0)"
                >Porteo</a>
              </li>
            </ul>
          </div>
          <div class="form-group form-inline pull-right">
            <input v-model="search" type="search" class="form-control" placeholder="Buscar..."> &nbsp;
          </div>
          <div class="table-responsive tableFixHead">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>Placa</th>
                  <th>Conductor</th>
                  <th>Servicio</th>
                  <th>Características</th>
                  <th>Citas en proceso</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(truck,k) in filteredTruckList"
                  :key="k"
                  href="#"
                  active
                  class="flex-column align-items-start"
                >
                  <td>{{truck.plate}}</td>
                  <td>{{truck.driver ? `${truck.driver.name} ${truck.driver.last_name}` : ''}}</td>
                  <td>{{truck.service.name}}</td>
                  <td>
                    <div v-for="(item, j) in truck.types" :key="j">
                      <span class="badge badge-info">{{item.name}}</span>
                    </div>
                  </td>
                  <td>
                    <div v-for="(item, j) in truck.requeriments" :key="j">
                      <span
                        class="badge badge-default"
                      >{{`#${item.id} `}}-{{ item.date | formatDateTime}}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";
export default {
  name: "ModalTrucks",
  data() {
    return {
      truckSelected: {},
      trucks: [],
      serviceTrucks: [],
      search: "",
      serviceSelected: null
    };
  },
  computed: {
    filteredTruckList() {
      return this.serviceTrucks.filter(truck => {
        let plateCondition = truck.plate
          .toLowerCase()
          .includes(this.search.toLowerCase());
        let characCondition = truck.types.some(tt =>
          tt.name.toLowerCase().includes(this.search.toLowerCase())
        );

        return plateCondition || characCondition;
      });
    }
  },
  methods: {
    trucksByService(inland) {
      let code = "";
      if (inland) code = "INL";
      else code = "PORT";
      this.serviceSelected = code;
      this.serviceTrucks = this.trucks.filter(t => t.service.code === code);
    }
  },
  mounted() {
    api.get("/trucks").then(response => {
      this.trucks = response.trucks.filter(t => t.active);
      this.serviceTrucks = this.trucks;
    });
  }
};
</script>